import {InjectionToken} from '@angular/core';

export const IS_WORKBENCH_CONTEXT = new InjectionToken<boolean>('IS_WORKBENCH_CONTEXT');
